<template>
  <admin-wrapper
    title-translation-path="navbar.SCADA_JUNCTIONS"
    :has-buttons="false"
    :disabled="true"
    :moduleEnabler="moduleEnabler"
  />
</template>
<script>
import AdminWrapper from '@/components/AdminWrapper';
export default {
  name: 'ScadaJunctionsSettings',
  components: {
    AdminWrapper,
  },
  computed: {
    moduleEnabler() {
      return {
        name: 'scada_junctions_module_enabled',
        translationPath: 'admin.SCADA_JUNCTIONS',
        subtitle: this.$i18n.t('admin.moduleEnablerSubtitle', { suffix: this.$i18n.t('admin.SCADA_JUNCTIONS') }),
      };
    },
  },
};
</script>
